import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_themes'

export default function DreamThemesPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which dream themes show up for you?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamThemes.heading')}
      buttons={[
        {
          text: `🚪 ${t('pages.onboarding.dreamThemes.options.beingLostOrTrapped')}`,
          value: 'Being lost or trapped',
        },
        {
          text: `🛫 ${t('pages.onboarding.dreamThemes.options.flyingOrFalling')}`,
          value: 'Flying or falling',
        },
        {
          text: `👥 ${t('pages.onboarding.dreamThemes.options.strangePeople')}`,
          value: 'Strange people',
        },
        {
          text: `🪞 ${t('pages.onboarding.dreamThemes.options.pastVersionsOfMyself')}`,
          value: 'Past versions of myself',
        },
        {
          text: `🌊 ${t('pages.onboarding.dreamThemes.options.naturalForces')}`,
          value: 'Natural forces',
        },
        {
          text: `😵 ${t('pages.onboarding.dreamThemes.options.notSureYet')}`,
          value: 'Not sure yet',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
